import { ChangePasswordUseCase } from '@/data/use-cases/auth-use-cases.js';
import { FirstAccessUseCase } from '@/data/use-cases/auth-use-cases.js';
import { ForgotPasswordUseCase } from '@/data/use-cases/auth-use-cases.js';
import { GetEntraOptionsUseCase } from '@/data/use-cases/auth-use-cases.js';
import { GetMeUseCase } from '@/data/use-cases/auth-use-cases.js';
import { RedeemEntraTicketUseCase } from '@/data/use-cases/auth-use-cases.js';
import { LoginUseCase } from '@/data/use-cases/auth-use-cases.js';
import { LogoutUseCase } from '@/data/use-cases/auth-use-cases.js';
import { ResetPasswordUseCase } from '@/data/use-cases/auth-use-cases.js';
import { ValidateResetTokenUseCase } from '@/data/use-cases/auth-use-cases.js';
import type { FetchHttpClient } from '@/infra/http/fetch-http-client.js';
import { AuthRepositoryImpl } from '@/infra/repositories/auth-repository-impl.js';
import { AuthController } from '@/presentation/controllers/auth-controller.js';

export const makeAuthController = (httpClient: FetchHttpClient): AuthController => {
    const repository = new AuthRepositoryImpl(httpClient);
    return new AuthController(
        new LoginUseCase(repository),
        new LogoutUseCase(repository),
        new GetMeUseCase(repository),
        new ForgotPasswordUseCase(repository),
        new ResetPasswordUseCase(repository),
        new ValidateResetTokenUseCase(repository),
        new FirstAccessUseCase(repository),
        new ChangePasswordUseCase(repository),
        new GetEntraOptionsUseCase(repository),
        new RedeemEntraTicketUseCase(repository)
    );
};
